import { render } from "./EcosistemaFrenkel.vue?vue&type=template&id=2c94f1f4"
import script from "./EcosistemaFrenkel.vue?vue&type=script&lang=js"
export * from "./EcosistemaFrenkel.vue?vue&type=script&lang=js"

import "./EcosistemaFrenkel.vue?vue&type=style&index=0&id=2c94f1f4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__